import React, { useEffect, useState } from "react";
import { Admin } from "../../pages";
import { AdminController } from "../../controllers";
import { adminStore } from "../../stores";

const AdminContainer = () => {
    const [loading, setLoading] = useState(false);
    const [goToRevoke, setGoToRevoke] = useState(false);
    const [goToAdd, setGoToAdd] = useState(false);
    const [goToEdit, setGoToEdit] = useState(false);    

    useEffect(() => {
        setLoading(true)
        const getAdmins = async () => {
            await Promise.all([
                AdminController.getAdminUsers(),
                AdminController.getPermissions(),                
                AdminController.getRoles(),
            ])
            setLoading(false);
        }
        getAdmins();
    }, [])

    const closeModal = () => {
        setGoToRevoke(false);
        setGoToAdd(false);
        setGoToEdit(false);
    }

    const handleAdd = () => {
        setGoToAdd(true);
    }

    const handleRevoke = (id) => {
        setGoToRevoke(true);
    }

    const handleEdit = () => {
        setGoToEdit(true);
    }

    const onSubmit = () => {
        closeModal();
    }
  
    return (
        <Admin
            goToEdit={goToEdit}
            admins={adminStore.admins}            
            handleAdd={handleAdd}
            goToAdd={goToAdd}
            onSubmit={onSubmit}
            goToRevoke={goToRevoke}
            handleEdit={handleEdit}
            handleRevoke={handleRevoke}
            closeModal={closeModal}            
            setLoading={setLoading}
            loading={loading}
        />
    )
}
export default AdminContainer;